import { Box, Button, CircularProgress } from "@mui/material";
import { COLORS, primaryContainedButtonSx } from "assets";
import { ReactNode } from "react";

export interface FormModalActionsProps {
  onCancel: () => void;
  cancelLabel: string;
  submitLabel: string;
  loading?: boolean;
  disabled?: boolean;
  submitType?: "submit" | "button";
  onSubmit?: () => void;
  submitIcon?: ReactNode;
}

const cancelSx = {
  minWidth: 120,
  height: 44,
  borderRadius: `${COLORS.radius.md}px`,
  borderColor: COLORS.surface.border,
  color: COLORS.surface.primaryText,
  fontWeight: 500,
  textTransform: "none"
};

const submitSx = {
  minWidth: 140,
  height: 44,
  borderRadius: `${COLORS.radius.md}px`,
  fontWeight: 500,
  textTransform: "none",
  ...primaryContainedButtonSx
};

export default function FormModalActions({
  onCancel,
  cancelLabel,
  submitLabel,
  loading,
  disabled,
  submitType = "submit",
  onSubmit,
  submitIcon
}: FormModalActionsProps) {
  return (
    <Box display="flex" justifyContent="flex-end" gap={1.5} mt={3}>
      <Button type="button" variant="outlined" onClick={onCancel} disabled={loading} sx={cancelSx}>
        {cancelLabel}
      </Button>
      <Button
        type={submitType}
        variant="contained"
        color="primary"
        disabled={disabled || loading}
        onClick={onSubmit}
        endIcon={loading ? <CircularProgress size={18} /> : submitIcon}
        sx={submitSx}
      >
        {submitLabel}
      </Button>
    </Box>
  );
}
